import { RequestModuleEnum } from 'shared/enums/request-module-enum'

export const coursesDependencies: RequestModuleEnum[] = [
  RequestModuleEnum.MembershipCourse,
  RequestModuleEnum.MembershipLightCourse,
]
